import {Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
const {Text} = Typography;
const Content = Layout;

const BAN = () => {
  return (
    <Layout style={{borderStyle: 'solid', borderWidth: '2vh', margin: '-2vh -2vh -2vh -2vh', background: appColors['ColorG2'], borderTopColor: appColors['ColorX'], borderBottomColor: appColors['ColorX'], borderRightColor: appColors['ColorX'], borderLeftColor: appColors['ColorX']}}>
      <Layout style={{background: 'transparent', margin: '5.2vh 5.2vh 5.2vh 5.2vh'}}>
        <Content style={{background: 'inherit'}}>
          <Text className='BaseText6'>Binding aptamers to nitrocellulose membrane: After determining that the biotin modifications work correctly. Finally, it will be time to test the same interaction on another platform. We will use a nitrocellulose membrane and fix in it the streptavidin with a binding buffer, then we will add the modified aptamer with biotin that will be bound to the streptavidin.</Text>
          <Layout style={{background: 'transparent'}}>
            <Content style={{marginLeft: '50%', transform: 'translateX(-50%)', marginTop: '2vh', width: '60vh', background: 'transparent'}}>
              <Image src='https://static.igem.wiki/teams/4464/wiki/wet-lab/12.png' preview={false}/>
              <p style={{textAlign: 'center'}}>Fig 11. Diagram of aptamers binding to a nitrocellulose plate. Created<br/>with BioRender.com</p>
            </Content>
          </Layout>
        </Content>
      </Layout>
    </Layout>
  );
};

export default BAN;
